import styled from 'styled-components';
import React from 'react';
import { Badge } from '@web-chat-core/ui-kit';
import { Container, Member, Avatar, Message, Row, Line } from './view';

export type SkeletonMemberBadge = { indexElement: number; value: number };
interface Props {
    count: number;
    withoutBackground?: boolean;
    heightOverflow?: boolean;
    badges?: SkeletonMemberBadge[];
    isSmall?: boolean;
    className?: string;
}

export const SkeletonMemberComponent: React.FC<Props> = props => {
    const { count, badges: badgesArray, withoutBackground = false, heightOverflow, isSmall, className } = props;

    const badges = new Map();
    badgesArray?.forEach(item => badges.set(item.indexElement, item.value));

    const countMembers = Array.from(Array(count));

    return (
        <Container
            withoutBackground={withoutBackground}
            heightOverflow={heightOverflow}
            className={className}
        >
            {countMembers.map((_, index) => {
                const existBadge = badges.has(index);

                return (
                    <Member
                        isSmall
                        key={index}
                    >
                        <Avatar isSmall={isSmall} />
                        <Message>
                            <Row>
                                <Line widthType="small" />
                            </Row>
                            <Row>
                                <Line widthType={existBadge ? 'withBadge' : 'full'} />
                                {existBadge && <Badge>{badges.get(index)}</Badge>}
                            </Row>
                        </Message>
                    </Member>
                );
            })}
        </Container>
    );
};

export default styled(SkeletonMemberComponent)``;
